import { Ns } from '@admin/i18n/types';
import { useTranslation } from '@cms/i18n/client';
import { type MenuItem } from '@common/clients/api';

import styles from './DropdownLink.module.scss';

interface Props {
    menuItem: MenuItem;
}

export const DropdownLink = ({ menuItem }: Props) => {
    const { t } = useTranslation(Ns.Admin);

    return (
        <div className={styles.container}>
            <a className={[styles.link, 'parent'].join(' ')} href={menuItem.href}>
                {t(menuItem.title)}
            </a>
            {menuItem?.children?.length ? (
                <div className={styles.dropDown}>
                    {menuItem.children.map((item, i) => {
                        return (
                            <a className={styles.link} href={item.href} key={i}>
                                {t(item.title)}
                            </a>
                        );
                    })}
                </div>
            ) : null}
        </div>
    );
};
